import httpClient from './httpClient';

export const expenseAccount = {
  getListExpense() {
    return httpClient.get('/api/adv/notes-frais');
  },
  getListTypeExpense() {
    return httpClient.get('/api/adv/notes-frais/types');
  },
  createNewExpense(data) {
    return httpClient.post('/api/adv/notes-frais', data)
  },
  updateExpense(data) {
    return httpClient.put(`/api/adv/notes-frais/${data.pkNoteDeFrais}`, data)
  },
  deleteExpense(pkNoteDeFrais) {
    return httpClient.delete(`/api/adv/notes-frais/${pkNoteDeFrais}`)
  }
}

export default expenseAccount;